<div class="flex flex-col-reverse full-width bg-surface lg:bg-transparent -mt-2">
  <div class="mb-3">
    <soft-step-header [steps]="steps" [currentIndex]="1" #stepper></soft-step-header>
  </div>
  <soft-default-header
    [overline]="'Schritt 2 von 4'"
    [title]="stepper.current()?.header | translate"
    [subtitle]="stepper.current()?.subHeader | translate"
  ></soft-default-header>
</div>

<div class="soft-overline mt-4">
  {{'#LAGERKORREKTUR_ARTIKEL.PAGES.ARTIKEL_AUSWAHL.ARTIKEL' | translate}}
</div>
<soft-artikel-menge-auswahl
  [lagerplatzInhalt]="(lagerplatz$ | async)?.inhalt"
  (artikelMengeChange)="onSelect($event)"
></soft-artikel-menge-auswahl>
